import Features from '@dashboard/enums/features';
import Plans from '@dashboard/enums/plans';
import { getPlan } from './plans';

export const features = {
  [Features.VARIANT_PRICE]: {
    label: 'Variant price',
    plans: [Plans.STARTER, Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.DOWNLOADS]: {
    label: 'Downloads',
    plans: [Plans.STARTER, Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.CUSTOMIZE_CONFIRMATION]: {
    label: 'Customize confirmation',
    plans: [Plans.STARTER, Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.CUSTOMIZE_EMAIL_CONFIRMATION]: {
    label: 'Customize email confirmation',
    plans: [Plans.STARTER, Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.SUBSCRIPTIONS]: {
    label: 'Subscriptions',
    plans: [Plans.STARTER, Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.ZAPIER]: {
    label: 'Zapier integration',
    plans: [Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.REWARDFUL]: {
    label: 'Rewardful integration',
    plans: [Plans.STARTER, Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.PAYMENT_PLAN]: {
    label: 'Payment plan',
    plans: [Plans.STARTER, Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.SUBSCRIPTION_START_DATE]: {
    label: 'Subscription start date',
    plans: [Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.SETUP_FEE]: {
    label: 'Setup fee',
    plans: [Plans.STARTER, Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.DISCOUNTED_FROM_PRICE]: {
    label: 'Discounted from',
    plans: [Plans.STARTER, Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.AG_PAY]: {
    label: 'Apple Pay / Google Pay',
    plans: [Plans.STARTER, Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.MULTIPLE_PAYMENT_METHODS]: {
    label: 'Multiple payment methods',
    plans: [Plans.STARTER, Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.CUSTOM_CSS]: {
    label: 'Custom CSS',
    plans: [Plans.STARTER, Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.CHECKOUT_PAGE_BADGE]: {
    label: 'Checkout Page badge',
    plans: [Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.LICENSE_KEYS]: {
    label: 'licenseKeys',
    plans: [Plans.STARTER, Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.BULK_DISCOUNTS]: {
    label: 'Bulk discounts',
    plans: [Plans.STARTER, Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.PAY_WHAT_YOU_WANT_PRICING]: {
    label: 'Pay what you want pricing',
    plans: [Plans.STARTER, Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.NOTIFY_EMAIL]: {
    label: 'Add more recipients',
    plans: [Plans.STARTER, Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.WEBSITE_URL]: {
    label: 'Website URL',
    plans: [Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.CUSTOM_DOMAIN]: {
    label: 'Custom domain',
    plans: [Plans.GROW, Plans.SCALE],
  },
  [Features.EMAIL_DOMAIN]: {
    label: 'Email domain',
    plans: [Plans.GROW, Plans.SCALE],
  },
  [Features.SEATS]: {
    label: 'Team members',
    plans: [Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.MULTI_STEP_CHECKOUT]: {
    label: 'Multi-step checkout',
    plans: [Plans.STARTER, Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.REDIRECT_TO_URL]: {
    label: 'Redirect to URL',
    plans: [Plans.STARTER, Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.HIDE_FIELDS]: {
    label: 'Hide fields',
    plans: [Plans.STARTER, Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.EXPORTS]: {
    label: 'Exports',
    plans: [Plans.PREMIUM, Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.DYNAMIC_PRICING]: {
    label: 'Dynamic pricing',
    plans: [Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.VARIANT_SHOW_HIDE_LOGIC]: {
    label: 'Show / hide logic',
    plans: [Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.WEBHOOKS]: {
    label: 'Webhooks',
    plans: [Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.GOOGLE_SHEETS]: {
    label: 'Google Sheets',
    plans: [Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.ONE_CLICK_UPSELLS]: {
    label: 'One-click upsells',
    plans: [Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.CUSTOM_FEES]: {
    label: 'Custom fees',
    plans: [Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
  [Features.MANUAL_PAYMENTS]: {
    label: 'Manual payments',
    plans: [Plans.LAUNCH, Plans.GROW, Plans.SCALE],
  },
};

const SEATS = {
  [Plans.STARTER]: 1,
  [Plans.PREMIUM]: 1,
  [Plans.LAUNCH]: 2,
  [Plans.GROW]: 3,
  [Plans.SCALE]: 10,
};

export const amountOfSeats = plan => {
  return SEATS[plan];
};

export const shouldHideFeature = (feature, canUse) => {
  const featureToCheck = features[feature];

  if (!featureToCheck) return false;

  if (canUse === false && featureToCheck.hideFeature) return true;

  return false;
};

export const canUseFeature = (feature, plan, sellerId) => {
  if (!feature) return true;

  const featureToCheck = features[feature];

  if (!featureToCheck) return true;

  // if featureToCheck contain sellerIds, it should only be available for those sellers
  if (featureToCheck.sellerIds && !featureToCheck.sellerIds?.includes(sellerId)) return false;

  if (featureToCheck.sellerIds?.includes(sellerId)) return true;

  return featureToCheck.plans.includes(plan);
};

export const getCheapestPlanForFeature = feature => {
  if (!features[feature]) return undefined;

  // get first plan in features[features] that is available
  const cheapestPlan = features[feature].plans.find(plan => getPlan(plan).available);

  if (!cheapestPlan) return undefined;

  return getPlan(cheapestPlan);
};
